export default "__VITE_ASSET__CcbeViKg__"